export default __webpack_public_path__ + "static/tableCloth.inspirations-449e1576eca1d3ca1bb0ac24ff5088a5.jpg";